import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from 'react-leaflet';
const selectedIcon = L.divIcon({
    className: 'leaflet-div-icon-reset',
    html: '<div class="leaflet-pin leaflet-pin-selected"></div>',
    iconSize: [24, 24],
    iconAnchor: [12, 12]
});
const ClickCapture = ({ onPick }) => {
    useMapEvents({
        click(event) {
            onPick({
                lat: Number(event.latlng.lat.toFixed(6)),
                lng: Number(event.latlng.lng.toFixed(6))
            });
        }
    });
    return null;
};
export const LocationPickerMap = ({ value, onChange }) => {
    const center = useMemo(() => [value.lat, value.lng], [value.lat, value.lng]);
    return (_jsx("div", { className: "overflow-hidden rounded-[28px] border border-slate-200 shadow-sm dark:border-white/10", children: _jsxs(MapContainer, { center: center, zoom: 12, scrollWheelZoom: true, className: "h-64 w-full", children: [_jsx(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), _jsx(ClickCapture, { onPick: onChange }), _jsx(Marker, { position: center, icon: selectedIcon, children: _jsx(Popup, { autoClose: false, closeButton: false, closeOnClick: false, children: _jsx("span", { className: "text-xs font-semibold", children: "Selected Location" }) }) })] }) }));
};
